'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (error, getState) {
    if (!(error.user_id || error.user) && getState) {
        var currentUserId = getState().getIn(['app', 'currentUser', '_id']);
        if (currentUserId) {
            error.user_id = currentUserId;
        }
    }
    return error;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/addUserId.js
// module id = 1660
// module chunks = 0